import React from 'react';
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
} from 'mdb-react-ui-kit';
import { DividendsSummary } from '../components/dividendsSummary';
import { DividendsTable } from '../components/dividendsTable';

function DividendsPage() {
    return (
      <>
        <div className='d-flex justify-content-center my-5' >
          <MDBCard style={{width: '80%'}}>
            <MDBCardBody>
              <MDBCardTitle className='mb-4'>Podsumowanie</MDBCardTitle>
              <DividendsSummary />
              <hr className="hr"/>
              <MDBCardTitle className='mb-4'>Lista otrzymanych dywidend</MDBCardTitle>
              <DividendsTable />
            </MDBCardBody>
          </MDBCard>
        </div>
      </>
    );
}

export default DividendsPage;
